<template>
  <div 
    class="lv-split-input__container"
  >
    <input
      type="text"
      :value="leadingValue"
      :disabled="leadingFields.disabled"
      :rules="leadingFields.rules"
      :required="leadingFields.required"
      :placeholder="$t(leadingFields.placeholder)"
      class="lv-split-input__text lv-split-input__text-left-radius"
      @input="$_onInput($event, 'leading')"
    >
    <input
      type="text"
      :value="trailingValue"
      :disabled="trailingFields.disabled"
      :rules="trailingFields.rules"
      :required="trailingFields.required"
      :placeholder="$t(trailingFields.placeholder)"
      class="lv-split-input__text lv-split-input__text-right-radius"
      @input="$_onInput($event, 'trailing')"
    >
  </div>
</template>

<script>
export default {
  props: {
    leadingFields: {
      type: Object,
      default() {
        return {
          disabled: true,
          rules: null,
          required: false,
          placeholder: null,
        };
      },
    },
    trailingFields: {
      type: Object,
      default() {
        return {
          disabled: false,
          rules: 'required',
          required: true,
          placeholder: '於此輸入連結結尾',
        };
      },
    },
    leadingValue: {
      type: String,
    },
    trailingValue: {
      type: String,
    }
  },
  methods: {
    $_onInput($event, type) {
      this.$emit(`${type}-input`, $event.target.value);
    }
  }
}
</script>